export function deleteArticle(data) {
    let { deleteArticleRequest, deleteArticleError, deleteArticleResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'app/stock/delete_article',
        this.createBundle('app/stock/delete_article', { article: data }, this.POST, deleteArticleRequest, deleteArticleResult, deleteArticleError)
    )
}
